import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MDFreedomFighterBodyModel } from 'src/app/model/MDFreedomFighterBodyModel';
import { RegistrationModerationDocumentModel } from 'src/app/model/RegistrationModerationDocumentModel';

@Component({
  selector: 'app-secure-md-freedom-fighter',
  templateUrl: './md-freedom-fighter.component.html',
  styleUrls: []
})
export class MDFreedomFighterComponent implements OnInit {
  @Input() registrationModerationDocument: RegistrationModerationDocumentModel;
  verifyForm: FormGroup = new FormGroup({});
  isVerifyDisabled: boolean;
  verifyErrorMessage: string;
  @Output() onSubmit = new EventEmitter<MDFreedomFighterBodyModel>();

  constructor() { }

  ngOnInit(): void { 
    console.log(this.registrationModerationDocument);
    this.verifyForm = new FormGroup({
      nameAsOnCertificate: new FormControl(null, [Validators.required]),
      isStampReadable: new FormControl(null, [Validators.required]),
      isStampFromDistrictCollectorOfficer: new FormControl(null, [Validators.required]),
      isSignaturePresent: new FormControl(null, [Validators.required]),
      isDateOfIssuePresent: new FormControl(null, [Validators.required]),
      // isQRCodePresent: new FormControl(null, [Validators.required]),
    });
  }

  onSubmitVerify() {
    console.log('verify submit clicked', this.verifyForm);
    this.verifyErrorMessage = null;
    if (this.verifyForm.valid) {
      this.onSubmit.emit(new MDFreedomFighterBodyModel(
        this.verifyForm.value.nameAsOnCertificate,
        this.verifyForm.value.isStampReadable,
        this.verifyForm.value.isStampFromDistrictCollectorOfficer,
        this.verifyForm.value.isSignaturePresent,
        this.verifyForm.value.isDateOfIssuePresent,
        // this.verifyForm.value.isQRCodePresent
        ));
    }
    else {
      this.verifyErrorMessage = "Please enter all mandatory fields";
      this.isVerifyDisabled = false;
    }
  }
}
